<template>
  <div class="user_detail_qa">
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="2" />
    <div v-if="isCloseSkeletonScreen">
      <div
        class="qa_item"
        v-if="msg_list.length"
        v-for="(item,index) in msg_list"
        :key="index"
        @click="$downapppop.open"
      >
        <p class="question_msg">{{item.question}}</p>
        <p class="user_and_time">
          <span class="user_name">{{userInfo.title}}</span>
          <span class="time_info">{{item.q_time}}</span>
        </p>
        <dl class="answer">
          <dt>
            <img :src="userInfo.image" alt />
          </dt>
          <dd class="is_see_no" v-if="item.is_see === 'no'">
            <i></i>
            <span>
              <span>{{item.fee}}&nbsp;金币查看回答</span>
            </span>
          </dd>

          <dd class="is_see_yes" v-else-if="item.is_radio === 'no'  && item.is_see === 'yes'">
            <div class="info">
              <i></i>
              <i></i>
            </div>
            <span class="see_answer">{{item.answer}}</span>
          </dd>
          <dd
            class="is_see_yes"
            :class="{is_radio:item.is_radio === 'yes'}"
            v-else-if="item.is_radio === 'yes'  && item.is_see === 'yes'"
          >
            <div class="info">
              <i></i>
              <i></i>
            </div>
            <span class="see_answer">
              <img :src="require('@/assets/images/icon_qa_audio_bg@2x.png')" alt />点击播放
            </span>
            <span class="audio_len">{{item.audio_len}}''</span>
          </dd>
        </dl>
      </div>
      <no-result v-if="!msg_list.length" title="此用户没有发布内容"></no-result>
      <no-data msg="没有更多数据了" v-if="msg_list.length&&!hasMore"></no-data>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="msg_list.length&&listLoading"
      ></loading>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import LiveListPub from "@/components/appLiveListPub/";
import noResult from "@/base/no-result/";
import noData from "@/base/nodata/";
export default {
  name: "UserProfiles",
  components: {
    // readMore,
    noResult,
    noData
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    }
  },
  data() {
    return {
      msg_list: [],
      user_id: parseInt(this.$route.params.id),
      isCloseSkeletonScreen: false,
      hasMore: true,
      listLoading: false,
      before: "",
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },
  created() {
    this.getQaList();
  },
  methods: {
    columnListMore() {
      if (!this.hasMore) return;
      if (this.listLoading) return;
      this.getQaList();
    },
    //获取老师个人主页  问答—》全部问答列表
    async getQaList() {
      this.listLoading = true;
      let qaList = await UserProfilesApi.getQaList(this.user_id, this.before);
      if (qaList.list && qaList.list.length) {
        if (this.before) {
          this.msg_list = this.msg_list.concat(qaList.list);
        } else {
          this.msg_list = qaList.list;
        }
        this.before = this.msg_list[this.msg_list.length - 1].sort_time;
      } else {
        this.hasMore = false;
      }

      this.listLoading = false;
      this.isCloseSkeletonScreen = true;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}

.user_detail_qa {
  .qa_item {
    background-color: #fff;
    .border-1px();
    padding: 14px;
    border-radius: 7px;
    margin-bottom: 9px;
    .question_msg {
      font-size: 15px;
      line-height: 21px;
      color: #333333;
    }

    .user_and_time {
      display: flex;
      align-items: center;
      height: 17px;
      color: #a0a0a0;
      font-size: 12px;
      line-height: 17px;
      margin: 12px 0 15px 0;

      .user_name {
        border-right: 0px solid #cbcbcb;
        padding-right: 9px;
      }

      .time_info {
        padding-left: 9px;
      }
    }

    .answer {
      display: flex;
      // align-items: center;
      dt {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        flex-shrink: 0;
        overflow: hidden;

        > img {
          width: 100%;
          height: 100%;
        }
      }

      > dd.is_see_no {
        display: flex;
        height: 35px;
        margin-left: 4px;
        font-size: 0;
        > i {
          height: 100%;
          width: 39px;
          background: url(../../assets/images/icon_qa_bg@2x.png);
          background-size: 100% 100%;
          background-position: 0 0;
          background-repeat: no-repeat;
        }

        > span {
          display: flex;
          height: 35px;
          padding: 0 29px 0 0;
          border-radius: 0 35px 35px 0;
          background: #ee696a;
          line-height: 35px;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          justify-content: center;
          align-items: center;
          margin-left: -0px;
          position: relative;
          left: -2px;
          > img {
            width: 13px;
            height: 15px;
            margin-right: 8px;
          }
        }
      }
      .is_see_yes {
        margin-left: 5px;
        position: relative;
        padding-left: 10px;
        margin-top: 3px;

        .see_answer {
          display: block;
          padding: 10px 15px;
          background: #fbfbfb;
          border: 1px solid #ffc746;
          border-radius: 15px;
          font-size: 13px;
          line-height: 19px;
          color: #636363;
          word-break: break-all;
          word-wrap: break-word;
        }
        > .info {
          position: absolute;
          width: 9px;
          height: 7px;
          background: #fbfbfb;
          z-index: 2;
          top: 5px;
          left: 5px;
          > i {
            display: block;
            height: 1px;
            background: #ffc746;
            width: 9px;
          }
          > i:last-child {
            transform: rotate(50deg) translateX(1px) translateY(2.5px);
            width: 9px;
          }
        }
        &.is_radio {
          display: flex;
          align-items: center;
          > .see_answer {
            background: #ffbd2b;
            display: flex;
            align-items: center;
            color: #ffffff;
            font-size: 13px;
            > img {
              width: 12px;
              height: 17px;
              margin-right: 10px;
            }
          }
          > .info {
            position: absolute;
            > img {
            }
          }
          .info::before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border-width: 11px 11px 0px;
            border-style: solid;
            border-color: #ffbd2b transparent transparent;
          }
          .audio_len {
            margin-left: 7px;
            color: #a0a0a0;
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>